// Servei de cerca de vehicles
import { getVehiclesByType } from './vehicleService'

/**
 * Cercar vehicles per terme de cerca
 * @param {string} searchTerm - Terme a cercar (marca, model, any, etc.)
 * @param {string} offerType - Tipus d'oferta: 'all', 'Comprar', 'Alquilar'
 * @returns {Promise<Array>} - Array de vehicles que coincideixen
 */
export const searchVehicles = async (searchTerm, offerType = 'all') => {
  try {
    // Si no hi ha terme de cerca, retornar array buit
    if (!searchTerm || searchTerm.trim() === '') {
      return []
    }

    // Obtenir vehicles segons el tipus d'oferta
    let vehicles
    if (offerType === 'all') {
      // Per a 'all', obtenir ambdós tipus i combinar-los
      // Això assegura que tinguem els camps complets (brand_name, model_name, images, etc.)
      const comprarVehicles = await getVehiclesByType('Comprar')
      const alquilarVehicles = await getVehiclesByType('Alquilar')
      vehicles = [...comprarVehicles, ...alquilarVehicles]
    } else {
      vehicles = await getVehiclesByType(offerType)
    }

    // Filtrar vehicles per terme de cerca
    const term = searchTerm.toLowerCase().trim()

    const filtered = vehicles.filter(vehicle => {
      // Cercar en marca
      const marca = (vehicle.brand_name || vehicle.nom_marca || '').toLowerCase()
      if (marca.includes(term)) return true

      // Cercar en model
      const modelo = (vehicle.model_name || vehicle.nom_model || '').toLowerCase()
      if (modelo.includes(term)) return true

      // Cercar en any
      const year = String(vehicle.any || '')
      if (year.includes(term)) return true

      // Cercar en preu
      const precio = String(vehicle.preu || '')
      if (precio.includes(term)) return true

      // Cercar en quilometratge
      const km = String(vehicle.kilometratge || '')
      if (km.includes(term)) return true

      // Cercar en tipus de combustible
      const combustible = (vehicle.nom_combustible || '').toLowerCase()
      if (combustible.includes(term)) return true

      // Cercar en descripció
      const descripcion = (vehicle.descripcio || '').toLowerCase()
      if (descripcion.includes(term)) return true

      return false
    })

    return filtered
  } catch (error) {
    console.error('Error en searchVehicles:', error)
    throw error
  }
}
